module.exports = __webpack_public_path__ + "img/alert-triangle.21c6d17e.svg";